import script from "./LimitedCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./LimitedCell.vue?vue&type=script&setup=true&lang=ts"

import "./LimitedCell.vue?vue&type=style&index=0&id=a3f63784&lang=scss&scoped=true"
import "./LimitedCell.vue?vue&type=style&index=1&id=a3f63784&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3f63784"]])

export default __exports__